<template>
    <div class="CenterPanel">
        <div class="CenterPanel-top">
            <div class="CenterPanel-top-title">
                <div class="name">光伏建设</div>
                <div class="value">截止：2023.05.01</div>
            </div>
            <div class="CenterPanel-top-contentCenter">
                <TopCenterContent :listData="topCenterList" />
            </div>
            <div class="CenterPanel-top-contentFooter">
                <TopFooterContent />
            </div>
        </div>
        <div class="CenterPanel-bottom">
            <div class="CenterPanel-bottom-title">
                <div class="name">EIOT</div>
                <div class="value">WLAN/LoRa/Zigbee/Bluetooth/4G/NB-loT/MQTT</div>
            </div>
            <div class="CenterPanel-bottom-contentCenter">
                <HeadTips :listData="bottomCenterList" className="bottomCenterList" twoLine />
            </div>
            <div class="CenterPanel-bottom-contentFooter">
                <BottomFooterContent :listData="bottomFooterList" />
            </div>
        </div>
    </div>
</template>

<script>
import HeadTips from "@/components/smartEnergy/HeadTips";
import TopFooterContent from "./TopFooterContent";
import TopCenterContent from "./TopCenterContent";
import BottomFooterContent from "./BottomFooterContent";
export default {
    name: "CenterPanel",
    props: {},
    components: {
        HeadTips, BottomFooterContent, TopCenterContent, TopFooterContent
    },
    data() {
        return {
            topCenterList: [{
                name: '电站数量',
                value: 117,
                unit: '个'
            }, {
                name: '逆变器',
                value: 218,
                unit: '台'
            }, {
                name: '装机容量',
                value: 8620,
                unit: 'kwp'
            }, {
                name: '阵列面积',
                value: 15700,
                unit: 'm³'
            },],
            bottomCenterList: [{
                value: 191,
                valueTotal: 2312,
                name: '网关',
                nameTotal: '中继网关',
                rateFlag: true,
            }, {
                value: 28,
                name: '接入设备类型',
            }, {
                value: 7875,
                name: '设备接入量',
            }, {
                value: 7726,
                name: '在线设备',
            }, {
                value: 149,
                name: '离线设备',
            }, {
                value: 329,
                name: '报警设备',
            }],
            bottomFooterList: [{
                name: '今日报警数量',
                value: 191,
                rateList: [{
                    name: '日环比',
                    value: '13%',
                    arrow: 'down'
                }],
                alarmName: '日均报警',
                alarmValue: 138,
            }, {
                name: '本周报警数量',
                value: 564,
                rateList: [{
                    name: '环比',
                    value: '7%',
                    arrow: 'up'
                }],
                alarmName: '周均报警',
                alarmValue: 515,
            }, {
                name: '本月报警数量',
                value: 5542,
                rateList: [{
                    name: '环比',
                    value: '7%',
                    arrow: 'up'
                }],
                alarmName: '月均报警',
                alarmValue: 4951,
            }]
        }
    },
    computed: {},
    methods: {},
    created() {
    },
    mounted() {
    },
}
</script> 

<style lang="scss" scoped>
.CenterPanel {
    width: 100%;
    height: 100%;

    &-top {
        height: calc(50% - 16px);
        // height: 342px;
        padding: 16px 30px 0;
        background: url("~@/assets/images/msgt/EIOTBg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &>div {
            width: 100%;
            // width: calc(100% - 60px);
        }

        &-title {
            height: 26px;
            @include setFlexBetween;

            .name {
                height: 22px;
                font-size: 22px;
                font-family: HelloFont-WenYiHei, HelloFont;
                font-weight: normal;
                color: #16E9F4;
                line-height: 22px;
            }

            .value {
                height: 14px;
                font-size: 14px;
                font-family: SourceHanSansSC-Normal, SourceHanSansSC;
                font-weight: 400;
                color: #B7C0CD;
                line-height: 14px;
            }
        }

        &-contentCenter {
            margin-top: 10px;
            height: 43%;
            // height: 134px;
        }

        &-contentFooter {
            margin-top: 15px;
            height: 43%;
            // height: 150px;
        }
    }

    &-bottom {
        margin-top: 16px;
        height: calc(50% - 48px);
        // height: calc( 100% - 406px);
        // height: 327px;
        padding: 16px 30px;
        background: url("~@/assets/images/msgt/EIOTBg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &>div {
            width: 100%;
            // width: calc(100% - 60px);
        }

        &-title {
            height: 26px;
            @include setFlexBetween;

            .name {
                height: 22px;
                font-size: 22px;
                font-family: HelloFont-WenYiHei, HelloFont;
                font-weight: normal;
                color: #16E9F4;
                line-height: 22px;
            }

            .value {
                height: 14px;
                font-size: 14px;
                font-family: SourceHanSansSC-Normal, SourceHanSansSC;
                font-weight: 400;
                color: #B7C0CD;
                line-height: 14px;
            }
        }

        &-contentCenter {
            margin-top: 10px;
            height: 42%;
            // height: 134px;
            @include setFlexBetween;
            flex-wrap: wrap;
        }

        &-contentFooter {
            margin-top: 15px;
            height: 42%;
            // height: 134px;
            @include setFlexBetween;
        }
    }
}
</style>